<template>
  <common-card class="mt-3">
    <v-row class="px-6">
      <v-col cols="12">
        <h1>Script</h1>
      </v-col>
    </v-row>

    <!-- Campañas | Roles | Estatus | (Tipo oculto) -->
    <v-row class="px-6">
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.campaniaIds"
          label="Campañas"
          :items="campanias"
          item-text="compania"
          item-value="id"
          multiple
          chips
          small-chips
          clearable
          outlined
          color="#00a7e4"
          :value-comparator="byId"
          :menu-props="{ maxHeight: 320 }"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0" small color="#00a7e4" dark>
              <span>{{ item.compania }}</span>
            </v-chip>
            <span v-else-if="index === 1" class="grey--text text-caption">
              (+{{ form.campaniaIds.length - 1 }} más)
            </span>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.rolId"
          label="Roles"
          :items="roles"
          item-text="nombre"
          item-value="rol"
          clearable
          outlined
          color="#00a7e4"
        />
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.estatus"
          label="Estatus"
          :items="estatusOptions"
          item-text="text"
          item-value="value"
          outlined
          color="#00a7e4"
        />
      </v-col>

      <!-- Tipo oculto -->
      <v-col cols="12" md="3" v-if="false">
        <v-autocomplete
          v-model="form.tipo"
          label="Tipo"
          :items="tipoOptions"
          item-text="text"
          item-value="value"
          outlined
          color="#00a7e4"
        />
      </v-col>
    </v-row>

    <!-- Nombre -->
    <v-row class="px-6">
      <v-col cols="12">
        <v-text-field
          v-model="form.nombre"
          label="Nombre del Script"
          outlined
          color="#00a7e4"
        />
      </v-col>
    </v-row>

    <!-- CKEditor -->
    <v-row class="px-6 mb-8">
      <v-col cols="12">
        <label class="body-2 font-weight-medium mb-2">Diseño del Script</label>
        <ckeditor v-model="form.html" :config="editorConfig" />
      </v-col>
    </v-row>

    <!-- Botones -->
    <v-row class="px-6">
      <v-col cols="12" class="text-right">
        <v-btn
          rounded
          outlined
          color="#00a7e4"
          dark
          class="mr-3"
          @click="$router.push('/administacion/scripts')"
        >
          Cancelar
        </v-btn>
        <v-btn class="common-botton mr-4" dark @click="guardar">
          {{ isEdit ? "Actualizar" : "Guardar" }}
        </v-btn>
      </v-col>
    </v-row>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import ckeditor from "ckeditor4-vue";
import {
  createScript,
  getScript,
  updateScript,
} from "@/services/scripts/scripts.service.js";
import { getRoles, getAgenteRoles } from "@/services/log/log.service.js";
import { getCampaingsList } from "@/services/campaings/campaing.service.js";

export default {
  components: { CommonCard, ckeditor: ckeditor.component },
  data() {
    return {
      editorConfig: { versionCheck: false },
      saving: false,
      form: {
        id: null,
        campaniaIds: [],
        //campaniaId: null,
        rolId: null,
        estatus: "INACTIVO",
        tipo: "GENERAL",
        nombre: "",
        html: "",
      },
      campanias: [],
      campaniasIndex: {},
      roles: [],
      allowedAreas: [],
      isAreaAdmin: false,
      estatusOptions: [
        { text: "Activo", value: "ACTIVO" },
        { text: "Inactivo", value: "INACTIVO" },
      ],
      tipoOptions: [
        { text: "Bienvenida", value: "BIENVENIDA" },
        { text: "Despedida", value: "DESPEDIDA" },
        { text: "General", value: "GENERAL" },
      ],
      areas_negocio: [],
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
  },
  async mounted() {
    await this.fetchCampanias();
    await this.fetchAllowedAreas();
    await this.fetchRoles();
    if (this.isEdit) {
      await this.load();
      this.$nextTick(() => {
        this.ensureCampaniasVisible();
        this.ensureSelectedRoleVisible();
      });
    }
  },
  watch: {
    campanias() {
      this.ensureCampaniasVisible();
    },
  },
  methods: {
    byId(a, b) {
      const va = typeof a === "object" ? a?.id : a;
      const vb = typeof b === "object" ? b?.id : b;
      return Number(va) === Number(vb);
    },

    async fetchAllowedAreas() {
      try {
        const resp = await getAgenteRoles();
        const items = Array.isArray(resp?.data)
          ? resp.data
          : Array.isArray(resp)
          ? resp
          : [];

        this.allowedAreas = [
          ...new Set(
            items
              .map((r) => r?.area_negocio)
              .filter((v) => v !== null && v !== undefined && v !== "")
          ),
        ].map(String);

        this.isAreaAdmin = items.some(
          (r) => String(r?.rol || "").toUpperCase() === "ADMIN"
        );
      } catch (e) {
        console.error("Error cargando áreas del agente", e);
        this.allowedAreas = [];
        this.isAreaAdmin = false;
      }
    },

    async fetchCampanias() {
      try {
        const res = await getCampaingsList({});
        const arr = Array.isArray(res?.campanias) ? res.campanias : [];

        this.campaniasIndex = arr.reduce((acc, c) => {
          acc[Number(c.id)] = c;
          return acc;
        }, {});

        const activos = arr.filter((c) => String(c?.status) === "1");
        this.campanias = activos
          .map((c) => ({
            id: Number(c.id),
            compania: c.medio || `#${c.id}`,
            raw: c,
          }))
          .sort((a, b) => a.compania.localeCompare(b.compania));
      } catch (e) {
        console.error("Error cargando campañas", e);
        this.campanias = [];
        this.campaniasIndex = {};
      }
    },

    async fetchRoles() {
      try {
        let dedup = await getRoles();
        //aqui se filtras las areas de negocio

        var areas_negocio = localStorage.getItem("areasNegocio");
        if (!areas_negocio) {
          this.areas_negocio = [];
        } else {
          this.areas_negocio = areas_negocio
            .split(",")
            .filter((v) => v.trim() !== "") // quita strings vacíos
            .map(Number);
        }
        let area_id = Number(localStorage.getItem("area_negocio_id"));
        if (!this.areas_negocio.includes(area_id)) {
          this.areas_negocio.push(area_id);
        }

        if (!this.isAreaAdmin && this.areas_negocio.length) {
          const idSet = new Set(this.areas_negocio.map(String));
          dedup = dedup.filter((x) => idSet.has(String(x.area_negocio)));
        }

        this.roles = dedup;
      } catch (e) {
        console.error("Error cargando roles", e);
        this.roles = [];
      }
    },

    titleCase(s) {
      return String(s)
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },

    ensureCampaniasVisible() {
      const selected = (this.form.campaniaIds || [])
        .map((v) => Number(typeof v === "object" ? v.id : v))
        .filter(Number.isFinite);

      const existentes = new Set(this.campanias.map((c) => Number(c.id)));
      selected.forEach((id) => {
        if (!existentes.has(id)) {
          const raw = this.campaniasIndex[id];
          const label = raw?.medio || `Campaña #${id} (inactiva)`;
          this.campanias.unshift({ id, compania: label, raw });
          existentes.add(id);
        }
      });
    },

    ensureSelectedRoleVisible() {
      const current = this.form?.rolId ? String(this.form.rolId) : null;
      if (!current) return;
      const exists = this.roles.some((r) => String(r.rol) === current);
      if (!exists) {
        this.roles.unshift({
          rol: current,
          nombre: this.titleCase(current) + " (fuera de tu área)",
          area_negocio: null,
        });
      }
    },

    async guardar() {
      this.saving = true;
      try {
        const payload = { ...this.form };

        const raw = Array.isArray(payload.campaniaIds)
          ? payload.campaniaIds
          : [];
        payload.campaniaIds = raw
          .map((x) => Number(typeof x === "object" ? x.id ?? x.value ?? x : x))
          .filter(Number.isFinite);

        delete payload.campaniaId;

        payload.rolId = payload.rolId ? String(payload.rolId).trim() : null;

        if (this.isEdit) {
          await updateScript(this.form.id || this.$route.params.id, payload);
        } else {
          await createScript(payload);
        }
        let texto = this.isEdit
          ? "Actualizacion de registro con exito"
          : "Registro guardado con exito";
        this.$toast.success(texto);
        this.$router.push("/administacion/scripts");
      } catch (e) {
        this.$toast.error("Upps a ocurrido un error...");
        console.error("Error guardando script", e);
      } finally {
        this.saving = false;
      }
    },

    async load() {
      try {
        const resp = await getScript(this.$route.params.id);
        const s = resp?.data || resp;

        const ids = Array.isArray(s.campaniaIds)
          ? s.campaniaIds
          : s.campaniaId != null
          ? [s.campaniaId]
          : [];

        const norm = [
          ...new Set(ids.map((x) => Number(x)).filter(Number.isFinite)),
        ];

        this.form = {
          ...this.form,
          ...s,
          campaniaIds: norm,
          rolId: s.rolId != null ? String(s.rolId) : null,
          estatus: s.estatus || this.form.estatus,
          tipo: s.tipo || this.form.tipo,
        };

        this.$nextTick(() => this.ensureCampaniasVisible());
      } catch (e) {
        console.error("Error cargando script", e);
      }
    },
  },
};
</script>
